<div class="dialog-viewer container">
  <h2 mat-dialog-title class="mat-h2 mb-4">Edit Membership Plan</h2>
  <div class="row">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  </div>
  <form [formGroup]="membershipPlanForm" (ngSubmit)="onSubmit()" class="membership-plan-form">
    <div class="row g-3">
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" required />
          <mat-error *ngIf="membershipPlanForm.get('name').hasError('required')">
            Name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Price</mat-label>
          <input matInput type="number" formControlName="price" min="0" required />
          <mat-error *ngIf="membershipPlanForm.get('price').hasError('required')">
            Price is required
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('price').hasError('min')">
            Price must be at least 0
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Billing Interval</mat-label>
          <mat-select formControlName="billingInterval" required>
            <mat-option *ngFor="let interval of billingIntervals" [value]="interval">
              {{ interval | titlecase }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="membershipPlanForm.get('billingInterval').hasError('required')">
            Billing interval is required
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('billingInterval').hasError('validationErrors')">
            {{ membershipPlanForm.get("billingInterval").errors?.validationErrors}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Billing Interval Count</mat-label>
          <input matInput type="number" formControlName="billingIntervalCount" min="1" required />
          <mat-error *ngIf="membershipPlanForm.get('billingIntervalCount').hasError('required')">
            Billing interval count is required
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('billingIntervalCount').hasError('min')">
            Must be at least 1
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Max Bookings Per Month</mat-label>
          <input matInput type="number" formControlName="maxBookingsPerMonth" min="0" required />
          <mat-hint>Leave 0 for unlimited bookings</mat-hint>
          <mat-error *ngIf="membershipPlanForm.get('maxBookingsPerMonth').hasError('required')">
            Max bookings per month is required
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('maxBookingsPerMonth').hasError('min')">
            Must be at least 0
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('maxBookingsPerMonth').hasError('validationErrors')">
            {{ membershipPlanForm.get("maxBookingsPerMonth").errors?.validationErrors}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Discount Percent</mat-label>
          <input matInput type="number" formControlName="discountPercent" min="0" max="100" />
          <mat-error *ngIf="membershipPlanForm.get('discountPercent').hasError('min')">
            Discount must be at least 0
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('discountPercent').hasError('max')">
            Discount cannot exceed 100
          </mat-error>
          <mat-error *ngIf="membershipPlanForm.get('discountPercent').hasError('validationErrors')">
            {{ membershipPlanForm.get("discountPercent").errors?.validationErrors}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12 d-flex align-items-center mb-3">
        <mat-checkbox formControlName="isActive">Active</mat-checkbox>
      </div>
      <div class="col-12 text-end">
        <button mat-raised-button color="warn" type="button" (click)="dialogRef.close('cancel')" class="me-2">
          Cancel
        </button>
        <button mat-raised-button type="submit" [disabled]="!membershipPlanForm.valid || isLoading">
          Update Membership Plan
        </button>
      </div>
    </div>
  </form>
</div>
